<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  import VueEasyLightbox from "vue-easy-lightbox";

  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      giveMemberListAllChecked: false,
      giveMemberListSearchKeyword: '',
      giveMemberList: [],
      searchCondition: '정회원+후원회원',
      rejectSMSDelete: true,
      mmsfile: null,
      smsSetting: {
        smsType: 'sms',
        balsin: '0534764766',
        susin: [],
        mmsImageUse: false,
        title: '',
        contents: '',
        mms_image_filename: '',
      },
      selectedImage: [],
      showImageModal: false,
      isButtonDisabled: false, 
      customNumber: '', // 임의번호 입력
      customNumbers: [], // 임의번호 리스트
      smsHistoryList: [], // 문자메세지 전송내역 리스트
      smsHistoryFields: [
        {key: 'mb_name', label: '발신자', thClass: 'col-3 text-center font-size-11', tdClass: 'text-center'},
        {key: 'susin', label: '수신자', thClass: 'col-3 text-center font-size-11', tdClass: 'text-center'},
        {key: 'insertTime', label: '전송일시', thClass: 'col text-center font-size-11', tdClass: 'col-2 text-center'},
      ],
      historyDetail: [], // 문자메세지 전송내역 상세
    };
  }
  
  export default {
    components: {
      VueEasyLightbox,
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
      characterCount() {
        return this.countCharacters(this.smsSetting.contents);
      },
      maxLength() {
        return this.smsSetting.smsType === 'sms' ? 90 : 2000;
      },
      historyDetailJson() {
        if (!this.historyDetail || !this.historyDetail.jsonData) return {};
        const data = this.historyDetail.jsonData;
        return typeof data === 'string' ? (JSON.parse(data || '{}') || {}) : data;
      }
    },
    mounted() {
    },
    created() {
      this.first()
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
  
          // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
          if (this.login.level < 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          } else {
            this.getGiveMemberList(); // 수신자 리스트 받아오자
            this.getSMSHistory(); // 문자메세지 전송내역 받아오자
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
      countCharacters(val) {
        return val.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '_').length;
      },
      // 수신자 선택하게 정,후원 회원 리스트 가져오자
      getGiveMemberList() {
        try {
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_sms_member_list',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_id": this.login.idx,
              "searchKeyword": this.giveMemberListSearchKeyword,
              "searchCondition": this.searchCondition,
              "rejectSMSDelete": this.rejectSMSDelete,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              if (res.data.giveMemberSmsList) {
                this.giveMemberList = res.data.giveMemberSmsList;
              } else {
                this.giveMemberList = [];
              }
              if (res.data.smsAddress) {
                this.smsSetting.balsin = res.data.smsAddress;
              } else {
                this.smsSetting.balsin = '';
              }
            } else {
              this.giveMemberList = [];
              this.$notify({ type: 'error', duration: 2000, title: '실패', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            this.giveMemberList = [];
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
        } catch (error) {
          console.log(error)
          this.giveMemberList = [];
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        }
      },
      checkAllGiveMemberList() {
        if (this.giveMemberListAllChecked) {
          this.giveMemberList.forEach(item => {
            item.isChecked = true;
          });
        } else {
          this.giveMemberList.forEach(item => {
            item.isChecked = false;
          });
        }
        this.smsSetting.susin = [];
        this.giveMemberList.forEach(item => {
          if (item.isChecked) {
            this.smsSetting.susin.push(item.phone);
          } else {
            this.smsSetting.susin = this.smsSetting.susin.filter(phone => phone != item.phone);
          }
        });
      },
      checkThisMember(item) {
        item.isChecked = !item.isChecked;
        if (item.isChecked) {
          this.smsSetting.susin.push(item.phone);
        } else {
          this.smsSetting.susin = this.smsSetting.susin.filter(phone => phone != item.phone);
        }
      },
      // 이미지 표시 URL 생성
      getImageUrl() {
        if (this.mmsfile && this.mmsfile instanceof File) {
          return this.createObjectURL(this.mmsfile);
        } else if (this.smsSetting.mms_image_filename) {
          return this.imagePath(this.smsSetting.mms_image_filename);
        }
        return '';
      },
      selectedType(val) {
        if (this.smsSetting.smsType == val) {
          return true;
        } else {
          return false;
        }
      },
      // SMS 타입 선택
      setSMStype: function(event) {
        let selected = event.target.value;
        this.smsSetting.smsType = selected;
      },
      // 문자 본문 내용 길이에따라 sms, lms, mms 타입 자동 선택 (기존에 mms 선택되어있으면 유지)
      contentsChange() {
        if (this.smsSetting.smsType == 'mms') {
          return;
        } else if (this.characterCount > 90) {
          this.smsSetting.smsType = 'lms';
        } else if (this.characterCount > 2000) {
          this.smsSetting.smsType = 'mms';
        } else {
          this.smsSetting.smsType = 'sms';
        }
      },
      // 파일첨부
      handleFileUpload(event) {
        const selectedFile = event.target.files[0];
        if (!selectedFile) {
          alert("파일을 선택하세요.");
          this.mmsfile = null;
          this.smsSetting.mmsImageUse = false;
          return;
        }

        // 확장자 검사 (jpg, jpeg, png만 허용) (대문자도 처리)
        const allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
        const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          alert("jpg, jpeg, png 파일만 업로드 가능합니다.");
          this.mmsfile = null;
          this.smsSetting.mmsImageUse = false;
          return;
        }
        this.mmsfile = selectedFile;
        this.smsSetting.mmsImageUse = true;
      },
      // 이미지 클릭시 모달 열기
      openImageModal(imagePath) {
        if (!imagePath) return;
        
        // 파일 선택으로 업로드한 경우 (Blob URL)
        if (imagePath.startsWith('blob:')) {
          this.selectedImage = imagePath;
        }
        // 발신내역의 이미지인 경우
        /*
        else if (imagePath.includes('/upload/_sms/')) {
          this.selectedImage = appConfig.edapi + imagePath;
          if (imagePath.includes('/upload/_sms/_templates/')) {
            this.selectedImage = appConfig.edapi +"/upload/_sms/_templates/"+ this.smsSetting.mms_image_filename;
          }
        }
        */
        // 그 외의 경우
        else {
          this.selectedImage = imagePath;
        }
        this.showImageModal = true;
      },
      // 이미지 모달용 URL 생성
      getModalImageUrl() {
        if (this.mmsfile && this.mmsfile instanceof File) {
          return this.createObjectURL(this.mmsfile);
        } else {
          //return appConfig.edapi +"/upload/_sms/_templates/"+ this.smsSetting.mms_image_filename;
        }
      },
      // 파일 URL 생성
      createObjectURL(file) {
        if (!file) return '';
        // File 객체인 경우에만 URL.createObjectURL 사용
        if (file instanceof File || file instanceof Blob) {
          return URL.createObjectURL(file);
        }
        return '';
      },
      sendBalsongSMS() {
        if (this.smsSetting.susin.length == 0 && this.customNumbers.length == 0) {
          this.$notify({ type: 'error', duration: 4000, title: '실패', text: '수신자를 선택해주세요.'})
        } else if (this.smsSetting.balsin =='') {
          this.$notify({ type: 'error', duration: 4000, title: '실패', text: '발신번호를 입력해주세요.'})
        } else if (this.smsSetting.smsType !='sms' && this.smsSetting.title =='') {
          this.$notify({ type: 'error', duration: 4000, title: '실패', text: '문자 제목을 입력해주세요.'})
        } else if (this.smsSetting.smsType =='mms' && this.smsSetting.mmsImageUse == false) {
          this.$notify({ type: 'error', duration: 4000, title: '실패', text: '첨부할 파일이 없으면 LMS로 선택해주세요'})
        } else if (this.smsSetting.contents.trim() =='' && this.customNumbers.length == 0) {
          this.$notify({ type: 'error', duration: 4000, title: '실패', text: '문자 본문을 입력해주세요.'})
        } else {
          // 버튼을 클릭하면 1초 동안 비활성화
          this.isButtonDisabled = true;
          // sms 아닐경우 문자제목 빈값인지도 체크하고, mms의 경우 첨부파일있는지 체크하자
          if (this.smsSetting.smsType !='sms' && this.smsSetting.title =='') {
            this.$notify({ type: 'error', duration: 5000, title: '실패', text: '문자 제목 넣어주세요'})
          } else {
            // mms 선택했는데 첨부파일 비어있으면 안내해주자
            if (this.smsSetting.smsType =='mms' && this.smsSetting.mmsImageUse == false) {
              this.$notify({ type: 'error', duration: 5000, title: '실패', text: '첨부할 파일이 없으면 LMS로 선택해주세요'})
            } else {
              const formData = new FormData();
              formData.append("smsSetting", JSON.stringify(this.smsSetting)); // JSON 문자열로 변환
              formData.append("customNumbers", JSON.stringify(this.customNumbers)); // 임의번호 리스트 JSON 문자열로 변환
              formData.append("mb_id", this.login.idx); // 로그인한 관리자 idx

              // MMS일 경우 파일 처리
              if (this.smsSetting.smsType === 'mms') {
                // 파일 선택으로 업로드한 경우
                if (this.mmsfile instanceof File) {
                  const reader = new FileReader();
                  reader.readAsArrayBuffer(this.mmsfile);
                  reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: this.mmsfile.type });
                    formData.append("file", blob, this.mmsfile.name);
                    // 파일을 Blob으로 변환 후 axios 요청 실행
                    this.sendFormData(formData);
                  };
                } 
              } else {
                // MMS가 아닐 경우 바로 전송
                this.sendFormData(formData);
              }
            }
          }
          // 1초 후에 버튼 활성화
          setTimeout(() => {
            this.isButtonDisabled = false;
          }, 1000);
        }
      },
      // 문자 보내기 실제 실행
      sendFormData(formData) {
        try {
          this.loadingBar(true);
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_send_sms',
            data: formData,
            headers: {
              'access-token': this.token,
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((response) => {
            if (response.data.type == 'success') {
              this.$notify({ type: 'success', duration: 2000, title: '성공', text: response.data.detail });
              this.getSMSHistory();
            } else {
              this.$notify({ type: 'error', duration: 2000, title: '실패', text: response.data.detail });
            }
            // EventBus.$emit("jumunListRefresh"); // 이벤트버스로 메인쪽 테이블 리프레시
            //this.sms_thislist(); // 문자발신 리스트 다시 불러오기
          })
          .catch((error) => {
            console.log(error);
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: error.response.data.detail });
          })
          .finally(() => {
            this.isButtonDisabled = false;
            this.loadingBar(false);
          });
        } catch (error) {
          console.log(error);
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: error.response.data.detail });
        } finally {
          this.isButtonDisabled = false;
          this.loadingBar(false);
        }
      },
      // 문자메세지 전송내역 받아오기
      getSMSHistory() {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/admin_read_sms_history',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_id": this.login.idx,
          },
        })
        .then((response) => {
          if (response.data.type == 'success') {
            this.smsHistoryList = response.data.smsHistoryList;
          } else {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: response.data.detail });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: error.response.data.detail });
        })
      },
      // 로딩 바
      loadingBar(val) {
        this.$nextTick(() => {
          const preloader = document.getElementById("preloader");
          const status = document.getElementById("status");
          
          if (preloader && status) {
            if (val === true) {
              preloader.style.display = "block";
              status.style.display = "block";
            } else {
              preloader.style.display = "none";
              status.style.display = "none";
            }
          }
        });
      },
      selectSearchCondition() {
        // 검색어는 지워주자
        this.giveMemberListSearchKeyword = ''
        // 수신자 리스트 초기화
        this.giveMemberList = [];
        // 담은 리스트 초기화
        this.smsSetting.susin = [];
        // 전체선택 풀어주자
        this.giveMemberListAllChecked = false;
        // 다시 불러오자
        this.getGiveMemberList();
      },
      searchKeywordChange() {
        // 수신자 리스트 초기화
        this.giveMemberList = [];
        // 담은 리스트 초기화
        this.smsSetting.susin = [];
        // 전체선택 풀어주자
        this.giveMemberListAllChecked = false;
        // 검색조건은 지워주자
        this.searchCondition = '전체명단'
        this.getGiveMemberList()
      },
      // 임의번호 리스트에 담자
      addCustomNumber() {
        this.customNumbers.push(this.customNumber);
        this.customNumber = '';
        this.$notify({ type: 'success', duration: 2000, title: '성공', text: '임의번호가 추가되었습니다.'})
      },
      // 임의번호 삭제
      removeCustomNumber(item) {
        this.customNumbers = this.customNumbers.filter(number => number != item);
      },
      // sms 전송내역 클릭 (모달 열리게하자)
      smsHistoryClick(row) {
        this.$bvModal.show('historyDetailModal')
        this.historyDetail = row;
      },
      // 파일 URL 가져오기
      fileUrl(fileName) {
        return appConfig.fileserver + '/sms/' + fileName;
      },
    },
  }
  </script>
  
  <template>
    <div class="rounded shadow">
      
      <!-- 히스토리 모달 -->
      <b-modal id="historyDetailModal" centered title="문자메세지 전송내역 상세" hide-footer size="lg">  
        <div v-if="historyDetail && Object.keys(historyDetail).length" class="table-responsive">
          <table class="table table-bordered table-sm font-size-12 mb-0">
            <tbody>
              <tr>
                <th class="bg-soft-secondary text-nowrap" style="width: 120px;">전송일시</th>
                <td>{{ historyDetail.insertTime }}</td>
              </tr>
              <tr>
                <th class="bg-soft-secondary text-nowrap">발신자</th>
                <td>{{ historyDetail.mb_name }}</td>
              </tr>
              <tr>
                <th class="bg-soft-secondary text-nowrap">전송결과</th>
                <td>
                  <span v-if="historyDetail.sendOk == 1" class="text-success"><i class="mdi mdi-check-circle me-1"></i>전송성공</span>
                  <span v-else class="text-danger"><i class="mdi mdi-close-circle me-1"></i>전송실패</span>
                </td>
              </tr>
              <template v-if="historyDetail.jsonData">
                <tr>
                  <th class="bg-soft-secondary text-nowrap">문자타입</th>
                  <td>{{ (historyDetailJson.smsType || '').toUpperCase() || '-' }}</td>
                </tr>
                <tr>
                  <th class="bg-soft-secondary text-nowrap">발신번호</th>
                  <td>{{ historyDetailJson.balsin || '-' }}</td>
                </tr>
                <tr v-if="historyDetailJson.title">
                  <th class="bg-soft-secondary text-nowrap">문자제목</th>
                  <td>{{ historyDetailJson.title }}</td>
                </tr>
                <tr>
                  <th class="bg-soft-secondary text-nowrap align-top">문자내용</th>
                  <td style="">
                    <!-- textarea로 처리하고 줄바꿈 되게-->
                    <textarea class="form-control form-control-sm" rows="10" readonly>{{ historyDetailJson.contents || '-' }}</textarea>
                  </td>
                </tr>
                <tr>
                  <th class="bg-soft-secondary text-nowrap align-top">첨부파일</th>
                  <td v-if="historyDetailJson.fileName" style="white-space: pre-wrap;">
                    <!-- 첨부파일이 이미지라면 이미지 나오게 -->
                    <img v-if="historyDetailJson.fileName.includes('.jpg') || historyDetailJson.fileName.includes('.png') || historyDetailJson.fileName.includes('.jpeg')" :src="fileUrl(historyDetailJson.fileName)" class="img-fluid w-100">
                    <div v-else>
                      <!-- 첨부파일이 이미지가 아니면 다운로드 받을 수 있게 -->
                      <a :href="fileUrl(historyDetailJson.fileName)" target="_blank" class="text-blue font-weight-bold">{{ historyDetailJson.fileName || '-' }}</a>
                    </div>
                  </td>
                  <td v-else>-</td>
                </tr>
                <tr>
                  <th class="bg-soft-secondary text-nowrap">수신자</th>
                  <td>{{ Array.isArray(historyDetailJson.susin) ? historyDetailJson.susin.join(', ') : '-' }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center text-muted py-3">선택된 전송내역이 없습니다.</div>
      </b-modal>


      <!-- 이미지 크게 -->
      <vue-easy-lightbox :visible="showImageModal" :index="0" :imgs="selectedImage" scrollDisabled='false' @hide="showImageModal = false"></vue-easy-lightbox>
      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">문자전송</h5>
        <div>
          <div class="row mt-4">
            <div class="col-xl-4 col-md-12 col-sm-12 mb-4">
              <div class="row justify-content-center">
                <div class="col-xl-12 col-md-12 col-sm-12">
                  <span class="text-secondary font-size-12 d-block mb-1">승인완료된 휴대폰연락처 있는 회원만 나옵니다.</span>
                  <div class="card mb-2">
                    <div class="card-body p-2">
                      <div class="row">
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
                          <div class="form-check">
                            <input type="checkbox" ref="rejectSMSDelete" v-model="rejectSMSDelete" class="form-check-input" id="rejectSMSDelete" @change="getGiveMemberList">
                            <label class="" for="rejectSMSDelete">
                              <span class="form-check-label" :class="{ 'text-blue font-weight-bold': rejectSMSDelete, 'text-secondary': !rejectSMSDelete }">문자수신거부 회원제외</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
                          <label for="searchCondition" class="font-size-12 text-muted mb-0 d-block">조회조건 선택</label>
                          <select class="form-control form-control-sm" id="searchCondition" v-model="searchCondition" @change="selectSearchCondition">
                            <option value="전체명단">전체명단</option>
                            <option value="정회원+후원회원">정회원+후원회원</option>
                            <option value="정회원">정회원</option>
                            <option value="후원회원">후원회원</option>
                            <option value="비회원">비회원</option>
                            <option value="회원유형없음">회원유형없음</option>
                            <option value="언론보도_기자">언론보도_기자</option>
                            <option value="기업/단체">기업/단체</option>
                            <option value="문자수신거부">문자수신거부</option>
                            <option value="이메일수신거부">이메일수신거부</option>
                          </select>
                        </div>
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
                          <div class="input-group">
                            <input type="text" class="form-control form-control-sm" placeholder="검색어 입력" v-model="giveMemberListSearchKeyword" @keyup.enter="searchKeywordChange">
                            <button class="btn btn-sm btn-square btn-blue" @click="searchKeywordChange">검색</button>
                          </div>
                        </div>
                      </div>

                      <!-- 전체 선택 또는 선택 해제하는 체크박스 -->
                      <div class="d-flex justify-content-between">
                        <div class="form-check">
                          <input 
                            @change="checkAllGiveMemberList"
                            class="form-check-input" 
                            type="checkbox" 
                            id="giveMemberListCheckAll" 
                            v-model="giveMemberListAllChecked">
                          <label for="giveMemberListCheckAll" class="form-check-label text-blue font-weight-bold">
                            전체 선택
                          </label>
                        </div>
                        <div class="text-blue font-weight-bold">
                          {{ smsSetting.susin.length }} 명
                        </div>
                      </div>
                      <hr class="my-2"></hr>
                      <!-- 스크롤바 추가 -->
                      <div class="overflow-auto bg-soft-secondary rounded" style="height: 200px;">
                        <div v-for="item in giveMemberList" :key="item.idx" class="">
                          <div class="font-size-12">
                            <div @click="checkThisMember(item)" class="cursor-pointer">
                              <span class="text-secondary font-weight-bold d-inline-block mr-1">
                                <i class="mdi mdi-checkbox-marked text-blue" v-if="item.isChecked"></i>
                                <i class="mdi mdi-checkbox-blank-outline text-secondary" v-else></i>
                              </span> 
                              <span class="text-secondary" :class="{ 'text-blue font-weight-bold': item.isChecked }">{{ item.name }}</span> 
                              <span class="text-secondary ml-1" :class="{ 'font-weight-bold': item.isChecked }">{{ item.memberType }}</span> 
                              <span class="text-secondary ml-1" :class="{ 'font-weight-bold': item.isChecked }">({{ item.phone }})</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 임의번호 -->
                  <div class="card mb-2">
                    <div class="card-header p-2">
                      <span class="text-secondary font-size-13">임의번호 추가하기</span>
                    </div>
                    <div class="card-body p-2">
                      <div class="row">
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
                          <div class="input-group">
                            <input type="text" class="form-control form-control-sm" placeholder="ex) 010-1234-5678" v-model="customNumber" @keyup.enter="addCustomNumber">
                            <button class="btn btn-sm btn-square btn-blue" @click="addCustomNumber">추가</button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-12 col-md-12 col-sm-12 mb-2">
                          <!-- select box로 임의번호 리스트 출력 (한줄 말고 여러줄 나오게 해서 삭제버튼도 나오게)-->
                          <div class="overflow-auto  rounded" style="height: 100px;">
                            <div v-for="(item, index) in customNumbers" :key="index" class="font-size-12">
                              <span class="badge badge-danger cursor-pointer" @click="removeCustomNumber(item)">삭제</span>
                              <span class="text-secondary font-weight-bold ml-1">{{ item }}</span> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-12 col-sm-12 mb-4">
              <div class="row justify-content-center">
                <div class="col-xl-12 col-md-12 col-sm-12 mb-1">
                  <label for="smsType" class="text-secondary font-size-12 d-block mb-1">문자타입</label>
                  <div id="smsType">
                    <div class="row">
                      <div class="col-4">
                        <label class="card-radio-label">
                          <input
                            type="radio"
                            name="type-method"
                            id="type-methodoption1"
                            class="card-radio-input"
                            value="sms"
                            :checked="selectedType('sms')"
                            @change=setSMStype($event)
                          />
                          <div class="card-radio card-sms-radio text-center">
                            <div class="font-weight-bold font-size-12">단문</div>
                            <div class="font-size-10">SMS</div>
                          </div>
                        </label>
                      </div>
                      <div class="col-4">
                        <label class="card-radio-label">
                          <input
                            type="radio"
                            name="type-method"
                            id="type-methodoption2"
                            class="card-radio-input"
                            value="lms"
                            :checked="selectedType('lms')"
                            @change=setSMStype($event)
                          />
                          <div class="card-radio card-sms-radio text-center">
                            <div class="font-weight-bold font-size-12">장문</div>
                            <div class="font-size-10">LMS</div>
                          </div>
                        </label>
                      </div>
                      <div class="col-4">
                        <label class="card-radio-label">
                          <input
                            type="radio"
                            name="type-method"
                            id="type-methodoption3"
                            class="card-radio-input"
                            value="mms"
                            :checked="selectedType('mms')"
                            @change=setSMStype($event)
                          />
                          <div class="card-radio card-sms-radio text-center">
                            <div class="font-weight-bold font-size-12">이미지</div>
                            <div class="font-size-10">MMS</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 발신번호 -->
                <div class="col-xl-12 col-md-12 col-sm-12 mb-1">
                  <div class="row">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                      <label for="smsBalsin" class="text-secondary font-size-12 d-block mb-1">발신번호</label>
                      <div class="input-group">
                        <input id="smsBalsin" type="text" class="form-control form-control-sm bg-soft-secondary font-size-12" placeholder="발신번호" v-model="smsSetting.balsin" disabled>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- mms 라면 이미지 첨부 -->
                <div v-if="smsSetting.smsType=='mms'" class="col-lg-12 col-sm-12">
                  <label for="smsImage" class="text-secondary font-size-12 d-block mb-1">이미지 첨부</label>
                  <div class="mb-2">
                    <label for="smsImage" class="btn btn-block btn-blue btn-sm">
                      <i class="mdi mdi-upload me-1"></i>jpg, jpeg, png파일 선택
                      <input id="smsImage" type="file" @change="handleFileUpload" class="d-none"/>
                    </label>
                  </div>
                  <div v-if="smsSetting.mmsImageUse" class="mt-2 mb-2">
                    <img 
                      :src="getImageUrl()"
                      class="history-thum rounded text-center img-fluid cursor-pointer border border-primary"
                      @click="openImageModal(getModalImageUrl())"
                    />
                  </div>
                </div>

                <!-- lms, mms 라면 문자제목 입력 -->
                <div v-if="smsSetting.smsType !=='sms'" class="col-lg-12 col-sm-12">
                  <label for="smsTitle" class="text-secondary font-size-12 d-block mb-1">문자 제목</label>
                  <div class="mb-2">
                    <input id="smsTitle" type="text" v-model="smsSetting.title" class="form-control form-control-sm font-size-12" />
                  </div>
                </div>


                <!-- 문자메세지 본문 내용 -->
                <div class="col-xl-12 col-md-12 col-sm-12 mb-1">
                  <label for="smsContents" class="text-secondary font-size-12 d-block mb-1">문자 본문</label>
                  <textarea id="smsContents" @change="contentsChange()" v-model="smsSetting.contents" class="form-control text-dark font-size-12" placeholder="" rows="15"></textarea>
                  <span class="text-secondary font-size-12">{{ characterCount }} / {{maxLength}}byte</span>
                  <span v-if="maxLength < characterCount" class="text-bold text-danger font-size-12"> !!!글자수가 초과되었습니다!!!</span>
                </div>

                <!-- 전송 버튼 -->
                <div class="col-lg-12 col-sm-12 mb-2">
                  <div class="row justify-content-center">
                    <div v-if="smsSetting.susin.length > 0 || customNumbers.length > 0" class="col-xl-12 col-md-12 col-sm-12">
                      <button id="sendSms" :disabled="isButtonDisabled" @click="sendBalsongSMS()" class="btn btn-block btn-blue btn-md">
                        {{ smsSetting.susin.length + customNumbers.length }} 명
                        문자 전송
                      </button>
                    </div>
                    <div v-else class="col-xl-12 col-md-12 col-sm-12">
                      <button id="sendSms" class="btn btn-block btn-blue btn-md disabled">
                        수신자를 선택해주세요
                      </button>
                    </div>
                    <div class="text-secondary font-size-12 mt-3">자동으로 중복번호는 제거하고 발송됩니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-12 col-sm-12 mb-4">
              <div class="row justify-content-center">
                <div class="col-xl-12 col-md-12 col-sm-12">
                  <span class="text-secondary font-size-12 d-block mb-1">문자메세지 전송내역 최근20건</span>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12">
                  <div class="table table-sm table-responsive font-size-12">
                    <b-table 
                      id="smsHistoryTable" 
                      ref="smsHistoryTable" 
                      :fields="smsHistoryFields" 
                      :items="smsHistoryList" 
                      :hover="true"
                      @row-clicked="smsHistoryClick($event)"
                      table-class="text-center cursor-pointer">
                      <template #cell(sendOk)="row">
                        <div v-if="row.item.sendOk == 1" class="">
                          <i class="mdi mdi-check text-blue"></i>
                        </div>
                        <div v-else class="">
                          <i class="mdi mdi-close text-danger"></i>
                        </div>
                      </template>
                      <template #cell(mb_name)="row">
                        <div class="">
                          {{ row.item.mb_name }}
                        </div>
                      </template>
                      <template #cell(susin)="row">
                        <div class="">
                          {{ Array.isArray(row.item.jsonData.susin) ? row.item.jsonData.susin.length : (row.item.jsonData.susin ? 1 : 0) }}명
                        </div>
                      </template>
                      <template #cell(insertTime)="row">
                        <div class="font-size-11">
                          <span v-if="row.item.sendOk == 1" class="text-success"><i class="mdi mdi-check-circle me-1"></i></span>
                          <span v-else class="text-danger"><i class="mdi mdi-close-circle me-1"></i></span>
                          {{ row.item.insertTime }}
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>